/**
 * Copyright (c) ACT, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { LineRawDataProps } from '.';

interface IData {
  date: string;
  DATA_POINT_1: number;
  DATA_POINT_2: number;
  DATA_POINT_3: number;
}

export const DATA = [
  {
    DATA_POINT_1: 200,
    DATA_POINT_2: 40,
    DATA_POINT_3: 452,
    date: '01/01',
  },
  {
    DATA_POINT_1: 200,
    DATA_POINT_2: 40,
    DATA_POINT_3: 452,
    date: '01/02',
  },
  {
    DATA_POINT_1: 200,
    DATA_POINT_2: 40,
    DATA_POINT_3: 452,
    date: '01/03',
  },
  {
    DATA_POINT_1: 200,
    DATA_POINT_2: 40,
    DATA_POINT_3: 452,
    date: '01/04',
  },
  {
    DATA_POINT_1: 200,
    DATA_POINT_2: 40,
    DATA_POINT_3: 452,
    date: '01/05',
  },
  {
    DATA_POINT_1: 200,
    DATA_POINT_2: 40,
    DATA_POINT_3: 452,
    date: '01/06',
  },
  {
    DATA_POINT_1: 200,
    DATA_POINT_2: 40,
    DATA_POINT_3: 452,
    date: '01/07',
  },
  {
    DATA_POINT_1: 190,
    DATA_POINT_2: 68,
    DATA_POINT_3: 300,
    date: '01/08',
  },
  {
    DATA_POINT_1: 50,
    DATA_POINT_2: 75,
    DATA_POINT_3: 401,
    date: '01/09',
  },
  {
    DATA_POINT_1: 67,
    DATA_POINT_2: 33,
    DATA_POINT_3: 234,
    date: '01/10',
  },
  {
    DATA_POINT_1: 43,
    DATA_POINT_2: 140,
    DATA_POINT_3: 111,
    date: '01/11',
  },
  {
    DATA_POINT_1: 0,
    DATA_POINT_2: 155,
    DATA_POINT_3: 50,
    date: '01/12',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '01/13',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '01/14',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '01/15',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '01/16',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '01/17',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '01/18',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '01/19',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '01/20',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '01/21',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '01/22',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '01/23',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '01/24',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '01/25',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '01/26',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '01/27',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '01/28',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '01/29',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '01/30',
  },
  {
    DATA_POINT_1: 200,
    DATA_POINT_2: 40,
    DATA_POINT_3: 452,
    date: '02/01',
  },
  {
    DATA_POINT_1: 200,
    DATA_POINT_2: 40,
    DATA_POINT_3: 452,
    date: '02/02',
  },
  {
    DATA_POINT_1: 200,
    DATA_POINT_2: 40,
    DATA_POINT_3: 452,
    date: '02/03',
  },
  {
    DATA_POINT_1: 200,
    DATA_POINT_2: 40,
    DATA_POINT_3: 452,
    date: '02/04',
  },
  {
    DATA_POINT_1: 200,
    DATA_POINT_2: 40,
    DATA_POINT_3: 452,
    date: '02/05',
  },
  {
    DATA_POINT_1: 200,
    DATA_POINT_2: 40,
    DATA_POINT_3: 452,
    date: '02/06',
  },
  {
    DATA_POINT_1: 200,
    DATA_POINT_2: 40,
    DATA_POINT_3: 452,
    date: '02/07',
  },
  {
    DATA_POINT_1: 190,
    DATA_POINT_2: 68,
    DATA_POINT_3: 300,
    date: '02/08',
  },
  {
    DATA_POINT_1: 50,
    DATA_POINT_2: 75,
    DATA_POINT_3: 401,
    date: '02/09',
  },
  {
    DATA_POINT_1: 67,
    DATA_POINT_2: 33,
    DATA_POINT_3: 234,
    date: '02/10',
  },
  {
    DATA_POINT_1: 43,
    DATA_POINT_2: 140,
    DATA_POINT_3: 111,
    date: '02/11',
  },
  {
    DATA_POINT_1: 0,
    DATA_POINT_2: 155,
    DATA_POINT_3: 50,
    date: '02/12',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '02/13',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '02/14',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '02/15',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '02/16',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '02/17',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '02/18',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '02/19',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '02/20',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '02/21',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '02/22',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '02/23',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '02/24',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '02/25',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '02/26',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '02/27',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '02/28',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '02/29',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '02/30',
  },
  {
    DATA_POINT_1: 200,
    DATA_POINT_2: 40,
    DATA_POINT_3: 452,
    date: '03/01',
  },
  {
    DATA_POINT_1: 200,
    DATA_POINT_2: 40,
    DATA_POINT_3: 452,
    date: '03/02',
  },
  {
    DATA_POINT_1: 200,
    DATA_POINT_2: 40,
    DATA_POINT_3: 452,
    date: '03/03',
  },
  {
    DATA_POINT_1: 200,
    DATA_POINT_2: 40,
    DATA_POINT_3: 452,
    date: '03/04',
  },
  {
    DATA_POINT_1: 200,
    DATA_POINT_2: 40,
    DATA_POINT_3: 452,
    date: '03/05',
  },
  {
    DATA_POINT_1: 200,
    DATA_POINT_2: 40,
    DATA_POINT_3: 452,
    date: '03/06',
  },
  {
    DATA_POINT_1: 200,
    DATA_POINT_2: 40,
    DATA_POINT_3: 452,
    date: '03/07',
  },
  {
    DATA_POINT_1: 190,
    DATA_POINT_2: 68,
    DATA_POINT_3: 300,
    date: '03/08',
  },
  {
    DATA_POINT_1: 50,
    DATA_POINT_2: 75,
    DATA_POINT_3: 401,
    date: '03/09',
  },
  {
    DATA_POINT_1: 67,
    DATA_POINT_2: 33,
    DATA_POINT_3: 234,
    date: '03/10',
  },
  {
    DATA_POINT_1: 43,
    DATA_POINT_2: 140,
    DATA_POINT_3: 111,
    date: '03/11',
  },
  {
    DATA_POINT_1: 0,
    DATA_POINT_2: 155,
    DATA_POINT_3: 50,
    date: '03/12',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '03/13',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '03/14',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '03/15',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '03/16',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '03/17',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '03/18',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '03/19',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '03/20',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '03/21',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '03/22',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '03/23',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '03/24',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '03/25',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '03/26',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '03/27',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '03/28',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '03/29',
  },
  {
    DATA_POINT_1: 156,
    DATA_POINT_2: 101,
    DATA_POINT_3: 356,
    date: '03/30',
  },
] as Array<IData>;

export const defaultLineKeys = ['2019', '2020', '2021'];

export const processDataFn = (data: Array<IData>): Array<LineRawDataProps> => {
  const processedData = data.map(d => {
    const dataObject = {
      '2019': d.DATA_POINT_1,
      '2020': d.DATA_POINT_2,
      '2021': d.DATA_POINT_3,
      label: d.date,
    };
    return dataObject;
  });

  return processedData;
};

export const yAxisDataKey = (): string => {
  let DATA_POINT_1 = 0;
  let DATA_POINT_2 = 0;
  let DATA_POINT_3 = 0;

  DATA.forEach(d => {
    if (Number(d.DATA_POINT_1) > DATA_POINT_1) DATA_POINT_1 = d.DATA_POINT_1;
    if (Number(d.DATA_POINT_2) > DATA_POINT_2) DATA_POINT_2 = d.DATA_POINT_2;
    if (Number(d.DATA_POINT_3) > DATA_POINT_3) DATA_POINT_3 = d.DATA_POINT_3;
  });

  if (DATA_POINT_1 >= DATA_POINT_2 && DATA_POINT_1 >= DATA_POINT_3)
    return '2019';

  if (DATA_POINT_2 >= DATA_POINT_1 && DATA_POINT_2 >= DATA_POINT_3)
    return '2020';

  if (DATA_POINT_3 >= DATA_POINT_2 && DATA_POINT_3 >= DATA_POINT_1)
    return '2021';

  return '2019';
};
